import { render, staticRenderFns } from "./mountItem.vue?vue&type=template&id=d2b3811c&"
import script from "./mountItem.vue?vue&type=script&lang=js&"
export * from "./mountItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports